<template>
<div>
  <div class="row">
    <div class="col-12 my-3">
        <a class="dropdown-item" href="#" @click="downloadAs('csv')"><vs-button color="primary" type="border"><i class="feather icon-download"></i> Export data ({{(data.length > 1 ? data.length+' instances':data.length+' instance')}}) to CSV</vs-button></a>
    
    </div>
  </div>
  <ag-grid-vue
    class="aggrid ag-theme-material"
    :columnDefs="columnDefs"
    :rowData="data"
    rowSelection="multiple"
    enableRtl= "false"
    floatingFilter= "true"
    filter= "true"
    pagination= "true"
    :paginationPageSize= limit
    pivotPanelShow= "always"
    colResizeDefault="shift"
    ref="agGridModular"
    animateRows= true
    resizable= true
    @grid-ready="onGridReady"
  >
  </ag-grid-vue>

</div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import './aggrid.css'
import './aggrid-material-theme.scss'
import './dark-layout.css'
import vSelect from 'vue-select'
  export default {
      name: 'agGridTableModular',
      props: ['data', 'columnDefs'],
      components: {
          AgGridVue
      },
      data() {
          return {
            limit: 10,
            gridApi: null,
            columnApi: null,
          }
      },
      beforeMount() {
      },
      created(){
      },
      mounted(){
      },
      watch:{
      },
      computed:{
      },
      methods: {
        downloadAs(type){
          switch (type) {
            case 'csv':
              this.gridApi.exportDataAsCsv()
              break;

            default:
              break;
          }
        },
        onGridReady(params) {
            this.gridApi = params.api;

            this.gridApi.showLoadingOverlay()
            this.gridApi.hideOverlay()
            this.columnApi = params.columnApi;
        },
        setLimit(limit){
          this.gridApi.paginationSetPageSize(Number(limit))
          this.limit = limit
        },
      }
  }
</script>

<style lang="scss">
  .patient-avatar{
    width: 40px;
    height: 40px;
    margin-top: 5px;
    margin-bottom: 5px;
    overflow: hidden;

    img{
      vertical-align: initial !important;
    }
  }
  img.swal2-image {
      width: auto !important;
  }
  .badge-top{
    margin-top: 5px
  }
  .date-muted{
    opacity: .5;
    font-size: .8em;
  }
  .ag-theme-material .ag-header-cell:hover{
    background-color: #242c5c !important;
  }
  .ag-floating-filter-input:read-only {
      background-color: transparent;

      .ag-input-field-input.ag-text-field-input{
        border-bottom: 1px solid #e2e2e24f;
        color: white !important;
        padding-bottom: 0px;
      }
  }
//   .ag-paging-button{
//     display: none !important;
//   }
  .ag-wrapper.ag-picker-field-wrapper {
    display: inline-flex;
    padding: 10px;
    width: 100%;

    .ag-picker-field-icon {
      position: absolute;
      right: 15px;
    }
     .ag-filter-condition {
       padding: 5px 10px;
      }
  }

  .ag-paging-number[ref=lbTotal] {
    display: none;
  }
  .ag-paging-description .ag-paging-number[ref=lbTotal]{
    display:initial;
  }
  .ag-paging-button-wrapper {
    background-color: #DAE1E7;
    border-radius: 50%;
    padding: .5rem 0;
    margin: 0 .5rem;
    color: #626262!important;

    .ag-icon {
      color: #2515be !important;
    }
    .ag-disabled {
      opacity: .5!important;
    }
  }
  .person-cell{
    line-height: normal !important;
  }

  .quarantine-dates-cell div {
      padding-top: 5px;
      height: 20px;
      line-height: 20px;
  }
  .ag-cell {
      border-bottom: 0 !important;
      border-top: 0 !important;
  }
  .ag-theme-material .ag-header-cell:hover {
      background-color: #242c5c24 !important;
  }
  img.missing-image {
      height: 320px;
      width: 240px;
      background: #f8f8f8;
      border: 0 !important;
      margin: auto;
  }
  .no-geofence{
    opacity: .1;
  }
</style>
